import { Body, Box, BoxProps, Container, Icon } from '@hover/blueprint';
import { IconProp } from '@hover/icons';
import React from 'react';

interface Props extends BoxProps {
  icon: IconProp;
  header: string;
  body: string;
}

const InfoBox: React.FC<Props> = ({ icon, header, body, ...restProps }) => (
  <Box flexDir="column" alignItems="center" {...restProps}>
    <Box
      h={500}
      w={500}
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
      mb={500}
      bg="primary.100"
    >
      <Icon icon={icon} m={0} size="large" color="brandNavy.500" />
    </Box>
    <Container px={0}>
      <Body
        as="h3"
        textAlign="center"
        textTransform="uppercase"
        isBold
        mb={500}
      >
        {header}
      </Body>
      <Body textAlign="center">{body}</Body>
    </Container>
  </Box>
);

export default InfoBox;
